import { inject, Service } from '@angular/core';
import { HttpService } from '@data-services/http';
import type { DoorCountResponse } from './door-count-response.model';
import type { GetDoorCountsRequest } from './get-door-counts-request.model';

@Service()
export class ProjectMetricsService {
  private readonly http = inject(HttpService);

  async getDoorCountsAsync(mbeIds: string[]): Promise<DoorCountResponse[]> {
    const request: GetDoorCountsRequest = { mbeIds };
    return this.http.postObjectAsync<GetDoorCountsRequest, DoorCountResponse[]>('mobile/projects/door-counts', request);
  }
}
